import { CodeBook } from "@king-ict/eupisi-ui/models";

import { CodeBookPagedFilter, OibServiceResult } from "../../../../models";
import {
  CommitteeType,
  OibFullInfoEmployee,
} from "../../../../models/Committee";
import {
  useLazyGetEmployeeOibQuery,
  useLazySearchCountyCommitteeEmployeeQuery,
  useLazySearchInstitutionCommitteeEmployeeQuery,
  useLazySearchMinistryCommitteeEmployeeQuery,
  useLazySearchRegionalCommitteeEmployeeQuery,
} from "../../../../queries";

interface IProps {
  committeeType: CommitteeType;
}

export const useCommitteeModalFetching = ({ committeeType }: IProps) => {
  const [searchInstitutionCommitteeEmployeeTrigger] =
    useLazySearchInstitutionCommitteeEmployeeQuery();

  const [searchCountyCommitteeEmployeeTrigger] =
    useLazySearchCountyCommitteeEmployeeQuery();

  const [searchMinistryCommitteeEmployeeTrigger] =
    useLazySearchMinistryCommitteeEmployeeQuery();

  const [searchRegionalCommitteeEmployeeTrigger] =
    useLazySearchRegionalCommitteeEmployeeQuery();

  const [getEmployeeOibTrigger] = useLazyGetEmployeeOibQuery();

  const getEmployees = async (
    search: CodeBookPagedFilter
  ): Promise<{ results?: CodeBook[] } | undefined> => {
    switch (committeeType) {
      case CommitteeType.Institution:
        return await searchInstitutionCommitteeEmployeeTrigger(search).unwrap();
      case CommitteeType.County:
        return await searchCountyCommitteeEmployeeTrigger(search).unwrap();
      case CommitteeType.Ministry:
        return await searchMinistryCommitteeEmployeeTrigger(search).unwrap();
      case CommitteeType.Regional:
        return await searchRegionalCommitteeEmployeeTrigger(search).unwrap();
    }
  };

  const getOibEmployee = async (
    oibEmployee: OibFullInfoEmployee
  ): Promise<OibServiceResult<OibFullInfoEmployee> | undefined> => {
    return await getEmployeeOibTrigger(oibEmployee).unwrap();
  };

  return {
    getEmployees,
    getOibEmployee,
  };
};
